import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=e0995a4e&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=e0995a4e&lang=scss&scoped=true&"
import style1 from "./ClientsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0995a4e",
  null
  
)

export default component.exports